import { render, staticRenderFns } from "./create-pro-page.vue?vue&type=template&id=553894fc&scoped=true&"
import script from "./create-pro-page.vue?vue&type=script&lang=js&"
export * from "./create-pro-page.vue?vue&type=script&lang=js&"
import style0 from "./create-pro-page.vue?vue&type=style&index=0&id=553894fc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553894fc",
  null
  
)

export default component.exports